module.exports = __webpack_public_path__ + "static/media/18.1b52c587.webp";